<div class="card-container" (mouseenter)="isHovered = true" (mouseleave)="isHovered = false">
    <!-- Commented due to bug COR-2682 -->
    <!-- <app-ask-copilot-button *ngIf="isHovered" [message]="copilotMessage" [top]="125" [marginRight]="16" (click)="onAskCopilotClick($event)"></app-ask-copilot-button> -->
    <app-card-popover *ngIf="isHovered" [timeInView]="cardData.timeInView" [viewability]="cardData.viewability"></app-card-popover>
    <div class="creative-background">
        <img [src]="cardData.imgUrl">
    </div>
  <div class="logo-container">
    <img [src]="cardData.logoPath" (error)="onImageError($event)" (mouseenter)="isLogoHovered = true" (mouseleave)="isLogoHovered = false">
    <span *ngIf="isLogoHovered && cardData.brandName">{{ cardData.brandName }}</span>
  </div>
  <div class="information-container">
        <div class="information-line">
            <div class="metric-name">{{attentionMetricName}}</div>
            <div class="metric-value">{{ cardData.attention }}%</div>
        </div>
        <div class="information-line">
            <div class="metric-name">CTR</div>
            <div class="metric-value">{{ cardData.ctr | percentage }}</div>
        </div>
        <div class="information-line">
            <div class="metric-name">CPM</div>
            <div class="metric-value">{{ cpm }}</div>
        </div>
    </div>
</div>
